import React, { useMemo } from 'react';
import { styled } from '@compiled/react';
import ShortcutIcon from '@atlaskit/icon/core/migration/link-external--shortcut';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { getOpsgenieInstanceUrl } from '@atlassian/jira-cross-flow-utils/src/services/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useHasCurrentUserOpsgenieAccount } from '@atlassian/jira-servicedesk-incident-management-common/src/services/has-opsgenie-account/index.tsx';
import { messages } from './messages.tsx';

const defaultOpsgenieInstanceUrl = 'https://www.opsgenie.com';

const onClick = () => {
	getOpsgenieInstanceUrl().then((instanceUrl) =>
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.open(
			`${instanceUrl !== null ? instanceUrl : defaultOpsgenieInstanceUrl}/incident/list`,
			'_blank',
		),
	);
};

const analyticsDetail = { itemId: 'gotoOpsgenie' } as const;

export const GotoOpsgenieMenuItem = () => {
	const [hasOpsgenieAccount] = useHasCurrentUserOpsgenieAccount();
	const { formatMessage } = useIntl();
	const ShortcutIconComponent = useMemo(() => <ShortcutIcon LEGACY_size="small" label="" />, []);

	if (hasOpsgenieAccount !== true) {
		return null;
	}

	return (
		<MenuItemContainer>
			<Tooltip
				content={formatMessage(messages.itemGotoOpsgenieItemTooltip)}
				onShow={(event) => fireUIAnalytics(event, 'opegenieIncidentsLinkTooltip')}
			>
				<MenuItem analytics={analyticsDetail} onClick={onClick} iconAfter={ShortcutIconComponent}>
					{formatMessage(messages.itemGotoOpsgenie)}
				</MenuItem>
			</Tooltip>
		</MenuItemContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MenuItemContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	margin: `-${gridSize * 0.75}px 0 ${token('space.075')}`,
	paddingTop: 0,
	paddingRight: token('space.050'),
	paddingBottom: 0,
	paddingLeft: token('space.050'),
});
